/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Loadingworkspace2Inputs */

const zh_organizationsettings_loadingworkspace2 = /** @type {(inputs: Organizationsettings_Loadingworkspace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作区加载中...`)
};

const en_organizationsettings_loadingworkspace2 = /** @type {(inputs: Organizationsettings_Loadingworkspace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading workspace...`)
};

const es_organizationsettings_loadingworkspace2 = /** @type {(inputs: Organizationsettings_Loadingworkspace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando espacio de trabajo...`)
};

/**
* | output |
* | --- |
* | "Loading workspace..." |
*
* @param {Organizationsettings_Loadingworkspace2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_loadingworkspace2 = /** @type {((inputs?: Organizationsettings_Loadingworkspace2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Loadingworkspace2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_loadingworkspace2(inputs)
	if (locale === "en") return en_organizationsettings_loadingworkspace2(inputs)
	return es_organizationsettings_loadingworkspace2(inputs)
});
export { organizationsettings_loadingworkspace2 as "organizationSettings_loadingWorkspace" }